import { Table } from 'antd';
export default Table;



// WEBPACK FOOTER //
// ./src/components/uielements/table.js